import { render, staticRenderFns } from "./GetGradualMessagesReceiver.vue?vue&type=template&id=70413fd5&"
import script from "./GetGradualMessagesReceiver.vue?vue&type=script&lang=js&"
export * from "./GetGradualMessagesReceiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports